export default {
  // Profile page sections
  myProfile: "My Profile",
  savedProducts: "Saved Products",
  myReviews: "My Reviews",
  settings: "Settings",
  
  // Profile settings
  profileSettings: "Profile Settings",
  country: "Country",
  phoneNumber: "Phone Number",
  socialMedia: "Social Media",
  privacySettings: "Privacy Settings",
  
  // Privacy options
  publicProfile: "Public Profile",
  privateProfile: "Private Profile",
  contactsOnly: "Contacts Only",
  
  // Profile actions
  uploadPhoto: "Upload Photo",
  removePhoto: "Remove Photo",
  uploadSuccess: "Photo uploaded successfully",
  uploadError: "Error uploading photo",
  photoTooBig: "Photo must be less than 2MB",
  
  // Social links
  instagramLink: "Instagram Profile",
  tiktokLink: "TikTok Profile",
  addSocialLinks: "Add Social Media Links",
  
  // Reviews section
  userReviews: "Reviews",
  noReviews: "No reviews yet",
  loginToSeeReview: "Login to see the full review",
  
  // Follow functionality
  following: "Following",
  follow: "Follow",
  followers: "followers",
  followSuccess: "Successfully followed user",
  unfollowSuccess: "Successfully unfollowed user",
  nowFollowing: "You are now following {{username}}",
  noLongerFollowing: "You are no longer following {{username}}",
  
  // Private profile messages
  followToRequest: "Follow this user to request access to their profile",
  followToSee: "Follow this user to see their reviews and favorite brands",
  
  // Expertise level
  level: "Level",
  expert: "Expert",
  
  // Favorite brands
  favoriteBrands: "Favorite Brands",
  addBrand: "Add a brand",
  brandAdded: "Brand added successfully",
  brandRemoved: "Brand removed successfully",
  
  // Tips preferences
  tipsPreferences: "Tips Preferences",
  acceptTips: "Accept Tips",
  tipPreferences: "Tip Preferences",
  
  // Save changes
  saveChanges: "Save Changes",
  changesSaved: "Changes saved successfully",
  savingChanges: "Saving changes...",
  errorSaving: "Error saving changes"
};